// composable: useUserApi.ts
import { inject, InjectionKey } from 'vue';
import { AgreementApiService } from './agreementApiService';

export const AGREEMENT_API_KEY: InjectionKey<AgreementApiService> = Symbol('AgreementApiService');

export function useAgreementApi(): AgreementApiService {
	const service = inject<AgreementApiService>(AGREEMENT_API_KEY);
	if (!service) throw new Error('AgreementApiService not provided');
	return service;
}
